export default __webpack_public_path__ + "static/media/warehouse-storage.123c9cbb.png";